import { useDispatch, useSelector } from 'react-redux'
import { getUUID } from '../../../../../../utility'
import Default from './Item/Default'
import { useNavigate } from 'react-router-dom'
import { AccountLink } from '@think-internet/zeus-frontend-package/auth/types'
import props from '../../../../../../redux/props'
// import useAuth from '../../../../../hooks/useOIDCAuth'
import Cookies from 'universal-cookie'
import { setLocal } from '../../../../../../redux/action/local'
import { NavigationItem } from '../../types'
import Button from '../../../../Button/Button'
import Call from '../../../../Call/Call'

type Props = {
  mobile?: boolean
  onClick?: () => void
  didScroll?: boolean
}

const Items: React.FC<Props> = ({ mobile = false, onClick = null, didScroll = false }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const accountLink: AccountLink = useSelector((s) => s[props.ACCOUNT_LINK])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isLoggedIn = () => !!accountLink

  const logout = () => {
    if (onClick) {
      onClick()
    }
    const cookies = new Cookies()
    cookies.remove('token', { path: '/' })
    dispatch(setLocal(props.ACCOUNT_LINK, null))
    dispatch(setLocal(props.TOKEN, null))
    navigate('/')
  }

  return (
    <>
      {isLoggedIn() ? (
        <>
          {t.header.navigation.ADMIN.map((item: NavigationItem) => (
            <Default onClick={onClick} key={getUUID()} data={item} didScroll={didScroll} />
          ))}
          <Button inverted={mobile} text={t.generic.logout} onClick={logout} />
        </>
      ) : (
        <>
          {t.header.navigation.default.map((item: NavigationItem) => (
            <Default mobile={mobile} onClick={onClick} key={getUUID()} data={item} didScroll={didScroll} />
          ))}
          <div className="lg:ml-10 flex flex-col lg:flex-row gap-3 lg:items-center">
            <div className="hidden xl:block text-sm lg:text-white font-light whitespace-nowrap">{t.generic.openHours}</div>
            <Call dark={mobile} />
          </div>
        </>
      )}
    </>
  )
}

export default Items
